var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "end-kanban-board" },
    [
      _c(
        "el-card",
        { staticClass: "metric-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { staticClass: "flx-between label-title" },
            [
              _c("div", [_vm._v("分拣看板 Painel de Triagem")]),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.changeDataType },
                  model: {
                    value: _vm.queryForm.dataType,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryForm, "dataType", $$v)
                    },
                    expression: "queryForm.dataType",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "HUB1" } }),
                  _c("el-radio-button", { attrs: { label: "HUB2" } }),
                ],
                1
              ),
              _c("div", { staticStyle: { "font-weight": "normal" } }, [
                _vm._v(
                  " 数据更新时间 Horário da Última Atualização de Dados: " +
                    _vm._s(_vm.updateTime || "--") +
                    " "
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "flex-start",
              staticStyle: {
                "font-size": "14px",
                "font-weight": "bold",
                "margin-top": "10px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("span", [_vm._v("大区 Região")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("placeOrder.pleaseChoose"),
                        clearable: "",
                        "collapse-tags": "",
                        filterable: "",
                        multiple: "",
                        size: "small",
                      },
                      on: { change: _vm.changeRegion },
                      model: {
                        value: _vm.queryForm.areaNameList,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "areaNameList", $$v)
                        },
                        expression: "queryForm.areaNameList",
                      },
                    },
                    _vm._l(_vm.regionList, function (item) {
                      return _c("el-option", {
                        key: item.regionId,
                        attrs: {
                          label: item.regionName,
                          value: item.regionName,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("span", [_vm._v("州 Estado")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                        clearable: "",
                        filterable: "",
                        multiple: "",
                        size: "small",
                      },
                      on: { change: _vm.changeStateList },
                      model: {
                        value: _vm.queryForm.stateList,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "stateList", $$v)
                        },
                        expression: "queryForm.stateList",
                      },
                    },
                    _vm._l(_vm.stateList, function (item) {
                      return _c("el-option", {
                        key: item.state,
                        attrs: { label: item.state, value: item.state },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex-start" },
                [
                  _c("span", [_vm._v("转运中心 Hub")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("GlobalSetObj.all"),
                        clearable: "",
                        "collapse-tags": "",
                        filterable: "",
                        multiple: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.queryForm.departmentList,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "departmentList", $$v)
                        },
                        expression: "queryForm.departmentList",
                      },
                    },
                    _vm._l(_vm.transferCenterList, function (item) {
                      return _c("el-option", {
                        key: item.siteId,
                        attrs: { label: item.siteName, value: item.siteName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "filter-section" },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "280px", "margin-right": "10px" },
                    attrs: {
                      "picker-options": _vm.pickerOptions,
                      align: "right",
                      "end-placeholder": "结束日期",
                      "range-separator": "~",
                      size: "small",
                      "start-placeholder": "开始日期",
                      type: "daterange",
                      "unlink-panels": "",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.timeValue,
                      callback: function ($$v) {
                        _vm.timeValue = $$v
                      },
                      expression: "timeValue",
                    },
                  }),
                  _c("el-button", {
                    attrs: {
                      icon: "el-icon-search",
                      size: "small",
                      type: "primary",
                    },
                    on: { click: _vm.getSearch },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-card",
                { staticClass: "metric-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "label-title" }, [
                    _vm._v(
                      "到发件数据监控 Monitoramento de Dados de Chegada e Envio"
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "flx-between",
                      staticStyle: { margin: "5px 0 10px 0" },
                    },
                    [
                      _c("div", [
                        _c("div", [
                          _vm._v("应到件票数 Qid de votos a serem colotados"),
                        ]),
                        _c("div", { staticClass: "label-item" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.dataObj01.exceptArrivalCnt.toLocaleString() ||
                                  0
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("div", [
                          _vm._v("实际到件票数 Qid de votos a real coletados"),
                        ]),
                        _c("div", { staticClass: "label-item" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.dataObj01.actualArrivalCnt.toLocaleString() ||
                                  0
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("div", [
                          _vm._v("到件差异 Diferenoa na etd.de colet"),
                        ]),
                        _c("div", { staticClass: "label-item" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.dataObj01.arrivalDiffCnt.toLocaleString() ||
                                  0
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "flx-between" }, [
                    _c("div", [
                      _c("div", [
                        _vm._v("应发件票数 Qtd. de votos a serem coletados"),
                      ]),
                      _c("div", { staticClass: "label-item" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.dataObj01.exceptDepartCnt.toLocaleString() ||
                                0
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c("div", [
                        _vm._v("实际发件票数 Qtd. de votos a serem coletados"),
                      ]),
                      _c("div", { staticClass: "label-item" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.dataObj01.actualDepartCnt.toLocaleString() ||
                                0
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c("div", [_vm._v("发件差异 Qtd. de votos a serem col")]),
                      _c("div", { staticClass: "label-item" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.dataObj01.departDiffCnt.toLocaleString() || 0
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c(
                "el-card",
                { staticClass: "metric-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "label-title" }, [
                    _vm._v("效率监控 Monitor"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "flx-between",
                      staticStyle: { margin: "5px 0 10px 0" },
                    },
                    [
                      _c("div", [
                        _c("div", [
                          _vm._v("卸车及时率 Tempo Médio de Triagem"),
                        ]),
                        _c("div", { staticClass: "label-item" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  (parseFloat(_vm.dataObj02.unloadOnTimeRate) ||
                                    0) * 100
                                ).toFixed(2) + "%"
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("div", [
                          _vm._v("准时发件率 Veículos necessários esti"),
                        ]),
                        _c("div", { staticClass: "label-item" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  (parseFloat(_vm.dataObj02.sendOnTimeRate) ||
                                    0) * 100
                                ).toFixed(2) + "%"
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "flx-between" }, [
                    _c("div", [
                      _c("div", [
                        _vm._v("平均分拣时长 Veículos necessários est"),
                      ]),
                      _c("div", { staticClass: "label-item" }, [
                        _vm._v(_vm._s(_vm.dataObj02.avgSortTime || 0)),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _vm.queryForm.dataType === "HUB1"
            ? _c(
                "el-col",
                { attrs: { span: 9 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "metric-card", attrs: { shadow: "hover" } },
                    [
                      _c("ShiftOperationEfficiency", {
                        ref: "ShiftOperationEfficiencyRef",
                        attrs: { "params-data": _vm.dataObj06 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.queryForm.dataType === "HUB2"
            ? _c(
                "el-col",
                { attrs: { span: _vm.queryForm.dataType === "HUB2" ? 7 : 5 } },
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "metric-card",
                      staticStyle: { height: "320px" },
                      attrs: { shadow: "hover" },
                    },
                    [
                      _c("div", { staticClass: "label-title" }, [
                        _vm._v(
                          " 班次作业效率HUB2 Eficiência operacional do turno (todo o dia) "
                        ),
                      ]),
                      _c("div", { staticStyle: { margin: "5px 0 10px 0" } }, [
                        _c(
                          "div",
                          { staticStyle: { margin: "10px 0 45px 0" } },
                          [
                            _c("div", { staticClass: "flx-center" }, [
                              _vm._v("分拣及时率 Eficiencia de produçao"),
                            ]),
                            _c("div", { staticClass: "label-itemNumber" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (
                                      (parseFloat(
                                        _vm.dataObj08.sortOnTimeRate
                                      ) || 0) * 100
                                    ).toFixed(2) + "%"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "40px" } },
                          [
                            _c("div", { staticClass: "flx-center" }, [
                              _vm._v("发货及时率 Taxa de entrega no prazo"),
                            ]),
                            _c("div", { staticClass: "label-itemNumber" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (
                                      (parseFloat(
                                        _vm.dataObj08.sendOnTimeRate
                                      ) || 0) * 100
                                    ).toFixed(2) + "%"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: _vm.queryForm.dataType === "HUB2" ? 7 : 5 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "metric-card",
                  staticStyle: { height: "320px" },
                  attrs: { shadow: "hover" },
                },
                [
                  _c("div", { staticClass: "label-title" }, [
                    _vm._v("在途与库存 Em trânsito com inventário"),
                  ]),
                  _c("div", { staticStyle: { margin: "5px 0 10px 0" } }, [
                    _c("div", { staticStyle: { margin: "10px 0 45px 0" } }, [
                      _c("div", { staticClass: "flx-center" }, [
                        _vm._v("在途票数 Veloulos necessarios est"),
                      ]),
                      _c("div", { staticClass: "label-itemNumber" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.dataObj03.onWayWaybillCnt.toLocaleString() ||
                                0
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticStyle: { "margin-bottom": "40px" } }, [
                      _c("div", { staticClass: "flx-center" }, [
                        _vm._v("实时库存 Inventario em tempo real"),
                      ]),
                      _c("div", { staticClass: "label-itemNumber" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.dataObj03.currentTimeWaybillCnt.toLocaleString() ||
                                0
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c(
                "el-card",
                { staticClass: "metric-card", attrs: { shadow: "hover" } },
                [
                  _c("HourlyEfficiency", {
                    ref: "HourlyEfficiencyRef",
                    attrs: { "params-data": _vm.dataObj07 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "metric-card", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "card-header" }, [
            _c("span", { staticClass: "label-title" }, [
              _vm._v("轨迹停更监控 Monitoramento de interrupção de trajeto"),
            ]),
          ]),
          _c("div", { staticClass: "flx-between" }, [
            _c("div", [
              _c("div", { staticClass: "metric-label" }, [
                _vm._v("停更1天 Parado há 1 dia"),
              ]),
              _c("div", { staticClass: "metric-value" }, [
                _vm._v(_vm._s(_vm.dataObj04.delayedOne.toLocaleString() || 0)),
              ]),
            ]),
            _c("div", [
              _c("div", { staticClass: "metric-label" }, [
                _vm._v("停更2天 Parado há 2 dia"),
              ]),
              _c("div", { staticClass: "metric-value" }, [
                _vm._v(_vm._s(_vm.dataObj04.delayedTwo.toLocaleString() || 0)),
              ]),
            ]),
            _c("div", [
              _c("div", { staticClass: "metric-label" }, [
                _vm._v("停更3天 Parado há 3 dia"),
              ]),
              _c("div", { staticClass: "metric-value" }, [
                _vm._v(
                  _vm._s(_vm.dataObj04.delayedThree.toLocaleString() || 0)
                ),
              ]),
            ]),
            _c("div", [
              _c("div", { staticClass: "metric-label" }, [
                _vm._v("停更7天 Parado há 7 dia"),
              ]),
              _c("div", { staticClass: "metric-value" }, [
                _vm._v(
                  _vm._s(_vm.dataObj04.delayedSeven.toLocaleString() || 0)
                ),
              ]),
            ]),
            _c("div", [
              _c("div", { staticClass: "metric-label" }, [
                _vm._v("停更15天 Parado há 15 dia"),
              ]),
              _c("div", { staticClass: "metric-value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.dataObj04.delayedFifteen.toLocaleString() || 0) +
                    " "
                ),
              ]),
            ]),
            _c("div", [
              _c("div", { staticClass: "metric-label" }, [
                _vm._v("停更30天 Parado há 30 dia"),
              ]),
              _c("div", { staticClass: "metric-value" }, [
                _vm._v(
                  _vm._s(_vm.dataObj04.delayedThirty.toLocaleString() || 0)
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "metric-card", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "card-header" }, [
            _c("span", { staticClass: "label-title" }, [
              _vm._v(
                "问题件数据监控 Monitoramento de dados de peças em questão"
              ),
            ]),
          ]),
          _vm.queryForm.dataType === "HUB1"
            ? _c("div", { staticClass: "flx-around" }, [
                _c("div", [
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("总计 total"),
                  ]),
                  _c("div", { staticClass: "label-itemNumber" }, [
                    _vm._v(
                      _vm._s(_vm.problemKanban.total.toLocaleString() || 0)
                    ),
                  ]),
                ]),
                _c("div", [
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("包裹被抢或被盗 Pacote roubado"),
                  ]),
                  _c("div", { staticClass: "label-itemNumber" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.problemKanban.packageRobOrStolen.toLocaleString() ||
                            0
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", [
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("包裹破损 Pacote avariado"),
                  ]),
                  _c("div", { staticClass: "label-itemNumber" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.problemKanban.packageDamage.toLocaleString() || 0
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", [
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("超时未妥投 Fora do prazo contratual de entrega"),
                  ]),
                  _c("div", { staticClass: "label-itemNumber" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.problemKanban.timeoutNotDelivered.toLocaleString() ||
                            0
                        ) +
                        " "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c(
            "el-table",
            {
              ref: "mapMain04TableRef",
              staticStyle: { width: "100%", "margin-top": "10px" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": {
                  "text-align": "center",
                  color: "#272727",
                  backgroundColor: "#efefef",
                },
                height: "280",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "序号 NO.",
                  type: "index",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "问题件原因 Motivo da Ocorrência",
                  prop: "reason",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.reason || "--"))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "问题件数量 Quantidade de anormal",
                  prop: "problemNum",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.problemNum.toLocaleString() || 0)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "占比 Proporção",
                  prop: "fakeSignCount",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.problemRate || 0))]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                { staticClass: "metric-card", attrs: { shadow: "hover" } },
                [
                  _c("MonitoringBagRecycling", {
                    ref: "MonitoringBagRecyclingRef",
                    attrs: { "params-data": _vm.dataObj05 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }